import { useState } from "react";
import { Truck } from "lucide-react";
import { api, inr, formatApiErrorDetail } from "@/lib/api";

export const eddText = (quote) => {
  const fmt = (days) => {
    const d = new Date();
    d.setDate(d.getDate() + days);
    return d.toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short" });
  };
  if (quote.source === "shiprocket" && quote.edd_days) return `by ${fmt(quote.edd_days)}`;
  return `between ${fmt(quote.edd_min || 3)} and ${fmt(quote.edd_max || 5)}`;
};

export const shippingText = (quote) =>
  quote.charge > 0 ? `${inr(quote.charge)} shipping` : "Free shipping";

export const DeliveryCheck = ({ product, qty = 1 }) => {
  const [pin, setPin] = useState("");
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const check = async () => {
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/shipping/estimate", { pincode: pin, items: [{ product_id: product.id, quantity: qty }] });
      setQuote(data);
    } catch (err) {
      setQuote(null);
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-8 border border-zinc-200 p-5" data-testid="delivery-check">
      <p className="text-[10px] uppercase tracking-[0.3em] text-zinc-400 flex items-center gap-2 mb-4">
        <Truck size={13} className="text-gold" /> Delivery options
      </p>
      <div className="flex gap-2">
        <input
          value={pin}
          onChange={(e) => { setPin(e.target.value.replace(/\D/g, "").slice(0, 6)); setQuote(null); setError(""); }}
          placeholder="Enter pincode"
          inputMode="numeric"
          data-testid="delivery-pincode-input"
          className="flex-1 bg-zinc-100 border border-zinc-200 text-zinc-900 text-sm px-4 py-3 placeholder:text-zinc-400 focus:outline-none focus:border-gold/60 transition-colors duration-300"
        />
        <button
          onClick={check}
          disabled={loading || pin.length !== 6}
          data-testid="delivery-check-btn"
          className="text-[10px] uppercase tracking-[0.25em] border border-gold/40 text-gold px-6 hover:bg-gold hover:text-white transition-colors duration-300 disabled:opacity-40"
        >
          {loading ? "…" : "Check"}
        </button>
      </div>
      {error && <p className="text-red-400 text-xs mt-3" data-testid="delivery-error">{error}</p>}
      {quote && (
        <div className="mt-4 space-y-1.5" data-testid="delivery-result">
          <p className="text-sm text-zinc-800">
            Delivery to <span className="font-medium">{quote.pincode}</span> {eddText(quote)} · {quote.courier}
          </p>
          <p className={`text-xs ${quote.charge > 0 ? "text-zinc-500" : "text-emerald-600"}`} data-testid="delivery-charge">
            {shippingText(quote)}{quote.source === "estimate" && quote.charge > 0 ? " · free above ₹999" : ""}
          </p>
        </div>
      )}
    </div>
  );
};
